export const sortCaseInsensitive = (a, b, targetKey) =>  {
    const lowercaseA = a[targetKey] ? a[targetKey].toLowerCase() : '';
    const lowercaseB = b[targetKey] ? b[targetKey].toLowerCase() : '';

    return lowercaseA.localeCompare(lowercaseB);
};